module.exports = __webpack_public_path__ + "img/SMRCN.57e643ef.png";